import React from 'react';
import { connect } from 'react-redux';

import '../styles/footer.css';

const Footer = ({auth}) => {
  const currentYear = new Date().getFullYear();
  const sectionTitleStyle = {
    color: '#4a5568',
    fontSize: '0.75rem',
    fontWeight: '600',
    textTransform: 'uppercase',
    letterSpacing: '0.05em',
    marginBottom: '0.5rem'
  };

  const linkStyle = {
    color: '#6c757d',
    textDecoration: 'none',
    fontSize: '0.85rem',
    transition: 'color 0.2s ease',
    display: 'block',
    marginBottom: '0.25rem'
  };

  const iconStyle = {
    color: '#6c757d',
    textDecoration: 'none',
    fontSize: '1.1rem',
    transition: 'color 0.2s ease'
  };

  return (
    <footer style={{
      borderTop: '1px solid #e2e8f0',
      padding: '2rem 0 1.5rem',
      marginTop: '2rem'
    }}>
      <div className="container">
        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(140px, 1fr))',
          gap: '2rem',
          marginBottom: '1.5rem'
        }}>
          {/* Site Links */}
          <div>
            <div style={sectionTitleStyle}>Site</div>
            <a href="/" style={linkStyle} className="footer-link">Home</a>
            <a href="/ai-notes" style={linkStyle} className="footer-link">AI Notes</a>
          </div>

          {/* Projects */}
          <div>
            <div style={sectionTitleStyle}>Projects</div>
            <a href="https://aidemolearn.com" target="_blank" rel="noopener noreferrer" style={linkStyle} className="footer-link">AI Demo & Learn</a>
            <a href="https://teqcrew.com" target="_blank" rel="noopener noreferrer" style={linkStyle} className="footer-link">Teq Crew</a>
            <a href="https://careeramplifier.com" target="_blank" rel="noopener noreferrer" style={linkStyle} className="footer-link">Career Amplifier</a>
            <a href="https://recapvid.com" target="_blank" rel="noopener noreferrer" style={linkStyle} className="footer-link">RecapVid</a>
          </div>

          {/* Tools */}
          <div>
            <div style={sectionTitleStyle}>Tools</div>
            <a href="/tools/article-to-media" style={linkStyle} className="footer-link">Article to Media</a>
          </div>

          {/* Connect */}
          <div>
            <div style={sectionTitleStyle}>Connect</div>
            <a href="/contact" style={linkStyle} className="footer-link">Contact</a>
            <div style={{ display: 'flex', gap: '0.75rem', marginTop: '0.25rem' }}>
              <a
                href="https://linkedin.com/in/elliotkoss"
                target="_blank"
                rel="noopener noreferrer"
                style={iconStyle}
                className="footer-icon"
              >
                <i className="bi bi-linkedin"></i>
              </a>
              <a
                href="https://github.com/elliotkoss"
                target="_blank"
                rel="noopener noreferrer"
                style={iconStyle}
                className="footer-icon"
              >
                <i className="bi bi-github"></i>
              </a>
            </div>
          </div>
        </div>

        <div style={{
          color: '#a0aec0',
          fontSize: '0.75rem',
          textAlign: 'center',
          paddingTop: '1rem',
          borderTop: '1px solid #e2e8f0',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          gap: '0.5rem'
        }}>
          <span>© 2025{currentYear > 2025 ? `–${currentYear}` : ''} Elliot Koss</span>
          <span>·</span>
          <a href="/terms-of-service" style={{ color: '#a0aec0', textDecoration: 'none' }} className="footer-link">Terms of Service</a>
          <span>·</span>
          <a href="/privacy-policy" style={{ color: '#a0aec0', textDecoration: 'none' }} className="footer-link">Privacy Policy</a>
        </div>
      </div>
    </footer>
  );
};

function mapStateToProps({auth}) {
  return { auth };
}

export default connect(mapStateToProps)(Footer);